export const personaCheckboxSelectMessageLabel = "NPb";
export const personaCheckboxSelectConversationLabel = "OPb";
export default {personaCheckboxSelectMessageLabel,personaCheckboxSelectConversationLabel};